import { EventEmitter, Input, Output } from '@angular/core';

import { ThfDynamicFormField } from '@totvs/thf-ui';

import { browserLanguage, thfLocaleDefault } from '../../../utils/util';

export const thfAdvancedFiltersLiteralsDefault = {
  en: {
    title: 'Advanced search',
    primaryActionLabel: 'Apply filters',
    secondaryActionLabel: 'Cancel'
  },
  es: {
    title: 'BÃºsqueda avanzada',
    primaryActionLabel: 'Aplicar filtros',
    secondaryActionLabel: 'Cancelar'
  },
  pt: {
    title: 'Busca avanÃ§ada',
    primaryActionLabel: 'Aplicar filtros',
    secondaryActionLabel: 'Cancelar'
  }
};

/**
 * @docsPrivate
 *
 * @description
 *
 * Filtro de busca avanÃ§ada criado a partir de um formulÃ¡rio dinÃ¢mico.
 * Componente de uso interno.
 */
export class ThfAdvancedFilterBaseComponent {

  private _filters: Array<ThfDynamicFormField> = [];

  literals = {
    ...thfAdvancedFiltersLiteralsDefault[thfLocaleDefault],
    ...thfAdvancedFiltersLiteralsDefault[browserLanguage()]
  };

  /**
   * ColeÃ§Ã£o de objetos que implementam a interface ThfDynamicFormField, para definiÃ§Ã£o dos campos que serÃ£o criados
   * dinamicamente.
   */
  @Input('t-filters') set filters(filters: Array<ThfDynamicFormField>) {
    this._filters = Array.isArray(filters) ? [...filters] : [];
  }

  get filters() {
    return this._filters;
  }

  /** FunÃ§Ã£o que serÃ¡ disparada e receberÃ¡ os valores do formulÃ¡rio ao ser clicado no botÃ£o buscar. */
  @Output('t-search-event') searchEvent = new EventEmitter<any>();

}
